import React from 'react';
import PropTypes from 'prop-types';

// Utils
import cn from '../../utils/cn';

import style from './Badge.module.css';

const Badge = ({
  label, children, size, color, className,
}) => (
  <div className={cn([className, style.badge, style[size], style[color]])}>
    { children || label }
  </div>
);

Badge.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.oneOf(['small', 'medium']),
  color: PropTypes.oneOf(['primary', 'secondary', 'accent', 'success', 'error', 'warning', 'grey']),
  className: PropTypes.string,
};

Badge.defaultProps = {
  label: null,
  children: null,
  size: 'small',
  color: 'primary',
  className: null,
};

export default Badge;
